import styled from "styled-components";

import { skeleton } from "components/shared/skeleton/Skeleton";

export const Skeleton = styled.div`
    width: 100%;
    height: 50px;

    ${skeleton("gray")}
`;

export const Label = styled.div`
    display: flex;
    align-items: center;
`;

export const Logo = styled.img`
    display: flex;
    align-items: center;
    width: 70px;

    margin-right: 45px;
`;

export const AccordionWrapper = styled.div`
    margin-bottom: 20px;
`;
